document.addEventListener("DOMContentLoaded", () => {
  subscribe(
    PUB_SUB_EVENTS.optionValueSelectionChange,
    ({ data: { event, target } }) => {
      const variantSelects = event.target.closest("variant-selects");
      if (!variantSelects) return;

      const card = variantSelects.closest(".card-wrapper");
      if (!card) return;

      const variantsData = JSON.parse(
        card.querySelector("[data-product-variants]").textContent
      );

      const selectedOptions = Array.from(
        card.querySelectorAll(
          "variant-selects select, variant-selects input:checked"
        )
      ).map((el) => el.value);

      const selectedVariant = variantsData.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

      if (!selectedVariant) return;

      const productDataEl = card.querySelector(".data-product-json");
      let adjustedInventory = null;
      if (productDataEl) {
        try {
          const productData = JSON.parse(productDataEl.textContent);
          if (
            productData.adjusted_inventory &&
            productData.adjusted_inventory[selectedVariant.id]
          ) {
            adjustedInventory =
              productData.adjusted_inventory[selectedVariant.id];
          }
        } catch (e) {
          console.warn(
            "Could not parse product data for adjusted inventory",
            e
          );
        }
      }

      const variantInput = card.querySelector('product-form input[name="id"]');
      if (variantInput) {
        variantInput.value = selectedVariant.id;
        variantInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      const submitButton = card.querySelector(
        'button[type="submit"][name="add"]'
      );
      const buttonText = submitButton?.querySelector(".quick_buy_text");

      if (adjustedInventory !== null) {
        const isAvailable = adjustedInventory.available;

        if (submitButton) {
          if (isAvailable) {
            submitButton.removeAttribute("disabled");
            variantInput?.removeAttribute("disabled");
            if (buttonText && submitButton.dataset.soldOutMessage) {
              buttonText.textContent =
                submitButton.dataset.soldOutMessage === "true"
                  ? window.variantStrings?.addToCart || "Add to cart"
                  : buttonText.textContent;
            }
          } else {
            submitButton.setAttribute("disabled", "disabled");
            variantInput?.setAttribute("disabled", "disabled");
            if (buttonText) {
              buttonText.textContent =
                window.variantStrings?.soldOut || "Sold out";
            }
          }
        }
      } else if (selectedVariant.available !== undefined) {
        const isAvailable = selectedVariant.available;

        if (submitButton) {
          if (isAvailable) {
            submitButton.removeAttribute("disabled");
            variantInput?.removeAttribute("disabled");
            if (buttonText && submitButton.dataset.soldOutMessage) {
              buttonText.textContent =
                submitButton.dataset.soldOutMessage === "true"
                  ? window.variantStrings?.addToCart || "Add to cart"
                  : buttonText.textContent;
            }
          } else {
            submitButton.setAttribute("disabled", "disabled");
            variantInput?.setAttribute("disabled", "disabled");
            if (buttonText) {
              buttonText.textContent =
                window.variantStrings?.soldOut || "Sold out";
            }
          }
        }
      }
    }
  );
});
